// extracted by mini-css-extract-plugin
export default {"role-assignments":"role-assignments--DmQZNuwlaN","roleAssignments":"role-assignments--DmQZNuwlaN"};